import { useEffect, useState } from 'react';

const MESSAGE_KEY = 'SRP_SHOW_INVENTORY_COUNTS';
const STORAGE_KEY = 'srp-show-inventory-counts';

function isValidMessage(
  ev: MessageEvent<unknown>
): ev is MessageEvent<{ type: typeof MESSAGE_KEY; enabled: boolean }> {
  return (
    typeof ev.data === 'object' &&
    ev.data != null &&
    'type' in ev.data &&
    ev.data.type === MESSAGE_KEY
  );
}

export default function useShowInventoryCounts() {
  const [showInventoryCounts, setShowInventoryCounts] = useState(false);

  useEffect(() => {
    setShowInventoryCounts(localStorage.getItem(STORAGE_KEY) === '1');

    const handleMessage = (
      ev: MessageEvent<{ type: string; enabled: boolean }>
    ) => {
      if (!isValidMessage(ev)) return;

      localStorage.setItem(STORAGE_KEY, ev.data.enabled ? '1' : '0');
      setShowInventoryCounts(ev.data.enabled);
    };

    window.addEventListener('message', handleMessage);

    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, []);

  return showInventoryCounts;
}
